import styled from 'styled-components';
import { CashPickupBoxProps } from '@repo/types/cashPickupBoxProps.type';

export const CashPickupIntroBox = ({
  index,
  title,
  description,
  image,
  isIndicator = true,
}: CashPickupBoxProps) => {
  const altText =
    typeof title === 'string' ? title : `Cash pickup guide step ${index}`;

  return (
    <Container>
      {isIndicator && (
        <StepIndicator>
          <StepNumber>{index}</StepNumber>
          <StepLine aria-hidden />
        </StepIndicator>
      )}
      <Content>
        <TextWrapper>
          <Title>{title}</Title>
          <Description>{description}</Description>
        </TextWrapper>
        <ImageWrapper>
          <Image src={image} alt={altText} />
        </ImageWrapper>
      </Content>
    </Container>
  );
};

const StepLine = styled.span`
  flex: 1;
  width: 2px;
  background: #f4f4f4;
  border-radius: 999px;
`;

const Container = styled.article`
  display: flex;
  gap: 8px;
`;

const StepIndicator = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;

const StepNumber = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 4px;
  background: #f5f6f7;
  color: #757575;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: -0.28px;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const Title = styled.h3`
  margin: 0;
  color: #333333;
  font-size: 20px;
  font-weight: 700;
  line-height: 150%;
  letter-spacing: -0.4px;
`;

const Description = styled.p`
  margin: 0;
  color: #777777;
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: -0.28px;
  white-space: pre-wrap;
`;

const ImageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  border-radius: 12px;
  background: #f4f8ff;
  overflow: hidden;
`;

const Image = styled.img`
  width: 100%;
  height: auto;
`;
